export type Theme = 'light' | 'dark';

const KEY = 'terum-theme';

export function resolveInitialTheme(): Theme {
  const stored = localStorage.getItem(KEY);
  if (stored === 'light' || stored === 'dark') return stored;
  // Redesign (2026-07-25): the cream light theme is the product default — an explicit user
  // toggle is the only way to dark, not the OS preference.
  return 'light';
}

export function applyTheme(theme: Theme): void {
  document.documentElement.setAttribute('data-theme', theme);
  // Legacy compat: the old stylesheet's `html.light …` rules — including surface-wrapper
  // token overrides like `html.light .v2-content.tb-root { --card / --bg … }` — still gate
  // on the `.light` class. Phase 2 moved theming to `data-theme`; keep toggling `.light`
  // too so those old rules keep flipping during the transition (otherwise surface content
  // falls through to its unconditional dark token defaults). Removed with the old CSS in Phase 9.
  document.documentElement.classList.toggle('light', theme === 'light');
  localStorage.setItem(KEY, theme);
}
